import { render, staticRenderFns } from "./ManagementPlanDetails.vue?vue&type=template&id=4fe92f0e"
import script from "./ManagementPlanDetails.vue?vue&type=script&lang=js"
export * from "./ManagementPlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports